(() => {
const toggle=document.querySelector('.menu-toggle'),nav=document.querySelector('#nav');
if(toggle&&nav){
const close=()=>{nav.classList.remove('open');toggle.setAttribute('aria-expanded','false');};
toggle.addEventListener('click',()=>{const open=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));});
nav.addEventListener('click',e=>{if(e.target.closest('a'))close();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('open')){close();toggle.focus();}});
document.addEventListener('click',e=>{if(!e.target.closest('.header'))close();});
}
const year=document.querySelector('#year');if(year)year.textContent=new Date().getFullYear();
})();
(() => {
  const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
  if (!preview) return;
  document.querySelectorAll('a[href]').forEach(link => {
    const raw = link.getAttribute('href');
    if (!raw || /^(#|mailto:|tel:)/i.test(raw)) return;
    const url = new URL(raw, window.location.href);
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('preview_theme_id', preview);
    link.href = url.href;
  });
})();
